import { render, staticRenderFns } from "./audioChat.vue?vue&type=template&id=cd41e850&scoped=true"
import script from "./audioChat.vue?vue&type=script&lang=js"
export * from "./audioChat.vue?vue&type=script&lang=js"
import style0 from "./audioChat.vue?vue&type=style&index=0&id=cd41e850&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd41e850",
  null
  
)

export default component.exports